document.addEventListener("teeinblue-event-after-cart-added", function () {
  fetch(`${window.themeVariables.routes.cartUrl}.js`)
    .then((res) => res.json())
    .then((cartData) => {
      fetch(window.location.pathname + "?sections=mini-cart")
        .then((res) => res.json())
        .then((cartContent) => {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              detail: {
                cart: { ...cartContent, ...cartData },
              },
            })
          );
          document.getElementById("mini-cart").open = true;
        });
    });
});

document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(".tee-product-price");
  const insertAfterElement = document.querySelector(
    ".product-meta__price-list-container"
  );
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }
});
